import { twMerge } from "tailwind-merge";

import { SearchField, SearchInput } from "@/components/search-field";

type SearchBarProps = {
  className?: string;
  inputValue: string;
  setInputValue: (value: string) => void;
};

export function SearchBar({
  className,
  inputValue,
  setInputValue,
}: SearchBarProps) {
  return (
    <div className={twMerge("w-full bg-bg-primary", className)}>
      <SearchField aria-label="Search field" className="w-full">
        <SearchInput
          onChange={(e) => setInputValue(e.target.value)}
          onClear={() => setInputValue("")}
          placeholder="Search..."
          value={inputValue}
        />
      </SearchField>
    </div>
  );
}
